import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactJWPlayer from 'react-jw-player';
import { getMediaKeyRequest } from 'shared/actions/mediaInfo.action';
import { startLoading, finishLoading } from 'shared/actions/loading.action';
import { pushModal } from 'shared/actions/modal.action';
import { getVideoPlayStatusCoupon } from 'shared/actions/coupon.action';
import { videoPlayStatus } from 'shared/actions/videoplay.action';

import classnames from 'classnames/bind';
import styles from './VideoPlayer.scss';

const cx = classnames.bind(styles);

const jwplayerConfig = {
  playerScript: process.env.REACT_APP_JW_PLAYER_SCRIPT,
  licenseKey: process.env.REACT_APP_JW_PLAYER_LICENSE_KEY,
};

const defaultPlayerId = 'drmuzy-player-id';

@connect(
  state => ({
    couponVideoPlayingStatus: state.shared.coupon.couponVideoPlayingStatus,
  }),
  {
    getMediaKeyRequest,
    startLoading,
    finishLoading,
    getVideoPlayStatusCoupon,
    pushModal,
    videoPlayStatus,
  },
)
class VideoPlayer extends Component {
  player = null;

  componentDidMount() {
    //mediaUrl을 받아오면 미디어키
    if (this.props.mediaUrl) {
      this.getMediaKey();
    }
  }

  componentDidUpdate(prevProps) {
    //props로 전달받은 mediaUrl 없다가 생겼을때 다시 실행
    if (!prevProps.mediaUrl && this.props.mediaUrl) {
      this.getMediaKey();
    }
    const { uid } = this.props.couponVideoPlayingStatus;

    const chk = () => {
      let dArr = Object.values(uid);
      return dArr.some(data => data.length >= 4);
    };
    if (prevProps.uid !== uid) {
      console.log(prevProps);
    }
    if (chk()) this.props.pushModal({ type: 'goSelling' });
  }

  //unique한 player id 리턴
  getPlayerId = () => {
    return this.props.playerId || defaultPlayerId;
  };

  //액션호출함수를 한번 더 감싸준다
  getMediaKey = () => {
    this.props.getMediaKeyRequest({
      type: '',
      step: this.props.videoIndex || 'STEP',
      mediaUrl: this.props.mediaUrl,
    });
  };

  //onReady에 setting
  handleReady = e => {
    // console.log(this.getPlayerId());
    this.player = window.jwplayer(this.getPlayerId()); //player id
    this.player.setControls(this.props.controls); //controls bar
    this.props.setPlayer(this.player);
    this.props.setFullscreen(true);
    // this.props.handleCloseVideo(e);
    // this.player.setFullscreen(true);
    // this.player.on('buffer', this.props.onLoading);
    // react-jw-player onBeforePlay 버그로
    // props로 전달할 수가 없다
    // this.player.on('beforePlay', e => {
    //   this.handleBeforePlay(e);
    // });
  };

  //play
  handlePlay = e => {
    this.player.setFullscreen(true);
    this.props.updatePlayerState({ playing: true });
    if (this.player.getState() !== 'playing') {
      console.log('after getState', this.player.getState());
    }
  };

  //pause
  handlePause = e => {
    // this.player.setFullscreen(false);
    this.props.updatePlayerState({ playing: false });
  };

  //resume
  handleResume = e => {
    this.props.updatePlayerState({ playing: true });
    // this.player.setFullscreen(this.props.fullscreen);
  };

  //stop
  handleStop = e => {
    this.props.updatePlayerState({ playing: false });
  };

  //complete
  handleComplete = e => {
    this.props.updatePlayerState({ playing: false, compeleted: true });
  };

  //fullscreen mode true
  handleEnterFullScreen = e => {
    console.log('after getState', this.player.getState());
    this.props.videoPlayStatus(this.player.getState());
    this.player.setFullscreen(true);
    this.props.handleCloseVideo(e, this.player.getState());
    this.player.play();
    // if (this.player.getState() === 'playing') return this.props.playStatus;
  };

  //fullscreen mode false
  handleExitFullScreen = e => {
    this.props.closeModal();
    this.props.videoPlayStatus(this.player.getState());
    this.player.pause();
    this.props.handleCloseVideo(e, this.props.playerId, this.props.videoIndex);
  };

  handleAutoStart = e => {};

  //replay
  replay = e => {
    this.player.play();
  };

  handleError = e => {
    this.props.updatePlayerState({ e });
  };

  render() {
    const playlist = [
      {
        file: this.props.mediaUrl,
        withCredentials: true, //필수옵션
        image: this.props.videoThumbnail,
      },
    ];

    const jwEvents = {
      onReady: this.handleReady,
      onPlay: this.handlePlay,
      onPause: this.handlePause,
      onResume: this.handleResume,
      onEnterFullScreen: this.handleEnterFullScreen,
      onExitFullScreen: this.handleExitFullScreen,
    };

    console.log(
      'getVideoPlayStatusCoupon',
      this.props.couponVideoPlayingStatus,
    );

    return (
      <div className={cx('VideoPlayer')}>
        <ReactJWPlayer
          className="jw-wrapper"
          playerId={this.getPlayerId()}
          playlist={playlist}
          {...jwplayerConfig}
          {...jwEvents}
          isAutoPlay={this.props.autoplay}
        />
        {this.props.showReplay && (
          <div className="dim">
            <i className="icon-replay" onClick={this.replay} />
          </div>
        )}
      </div>
    );
  }
}

export default VideoPlayer;
